import { api } from 'app/api';

export const getPdf = async (url: string): Promise<Blob> =>
  await api.get<Blob>(url, { responseType: 'blob' }).then(response => response.data);
